import { Colors } from "@jsq/ds/styles";
import { ConfirmDialog } from "./ConfirmDialog";

type ArchiveQueryModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isArchiving?: boolean;
};

export const ArchiveQueryModal = ({
  isOpen,
  onClose,
  onConfirm,
  isArchiving = false,
}: ArchiveQueryModalProps) => (
  <ConfirmDialog
    isOpen={isOpen}
    onClose={onClose}
    title="Archive query"
    heading="Archive query"
    description="This query will no longer be available for template creation"
    icon={{ type: "exclamation-triangle", color: Colors.Neutral600, variant: "outline" }}
    action={{
      kind: "confirm",
      confirmLabel: "Archive",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm,
      isConfirming: isArchiving,
      confirmTestId: "confirm-archive-query-btn",
    }}
    testId="confirm-archive-query-modal"
  />
);
